import { ActionTree } from "vuex";
import { State } from "./state";
import { findOne, create } from "@/store/Crud/functions/actions";

export default <ActionTree<State, any>>{
  findOne,
  create,
};
